import React from 'react';
import { IconProps } from '../types/types';

const HSBC: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" role="img" {...props}><path fill="#F0F3FA" d="M0 0h18v18H0z"/><path d="M12 13H6V5h6v8z" fill="#fff"/><path d="M3 9l3 4V5L3 9zM6 13h6L9 9l-3 4zM9 9l3-4H6l3 4zM12 5v8l3-4-3-4z" fill="#E71D1C"/></svg>
);

export default HSBC;